// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x87aQ","label":"styles_label__ETOp8"};